module.exports = __webpack_public_path__ + "img/extended.93e8c982.png";